// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scoreFont[data-v-49fd9edd]{color:#282c2e;font-size:16px;letter-spacing:.5px;line-height:1.25}.scorePanels[data-v-49fd9edd]{background-color:#e2e7ea;border:1px solid #e2e7ea;border-radius:1px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
